import { render } from "./App.vue?vue&type=template&id=a2b6a15c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a2b6a15c&lang=css"

import exportComponent from "C:\\Users\\kimjiwon\\Desktop\\테스트사이트\\메인페이지\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__